/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyCounselingSlotQuotaRequestBodyTypename = "PutPharmacyCounselingSlotQuotaRequestBody" as const;

/**
 *
 * @export
 * @interface PutPharmacyCounselingSlotQuotaRequestBody
 */
export interface PutPharmacyCounselingSlotQuotaRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutPharmacyCounselingSlotQuotaRequestBody
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof PutPharmacyCounselingSlotQuotaRequestBody
   */
  quota: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyCounselingSlotQuotaRequestBody
   */
  readonly __typename?: string;
}

export function PutPharmacyCounselingSlotQuotaRequestBodyFromJSON(
  json: any
): PutPharmacyCounselingSlotQuotaRequestBody {
  return PutPharmacyCounselingSlotQuotaRequestBodyFromJSONTyped(json, false);
}

export function PutPharmacyCounselingSlotQuotaRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyCounselingSlotQuotaRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyCounselingSlotQuotaRequestBodyTypename,

    date: json["date"],
    quota: json["quota"],
  };
}

export function PutPharmacyCounselingSlotQuotaRequestBodyToJSON(
  object?: PutPharmacyCounselingSlotQuotaRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date: value.date,
    quota: value.quota,
  };
}
